import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaLocalidade from './Components/TabelaVeiculo'
import TabelaVeiculo from './Components/TabelaVeiculo'


const mockPermissions = [
  {
    id: 1,
    placa: 'HVL8212',
    renavam: '8214532847',
    chassi: '12345678914521547',
    fabricante: 'HYUNDAI',
    modelo: 'HB0872',
    cor: 'PRETO',
    combustivel: 'GASOLINA',
    cliente: 'TERMACO TERM MAR CONT SERV ACESS LT',
    ativo: true,
  },
  {
    id: 2,
    placa: 'HVL8212',
    renavam: '8214532847',
    chassi: '12345678914521547',
    fabricante: 'HYUNDAI',
    modelo: 'HB0872',
    cor: 'PRETO',
    combustivel: 'GASOLINA',
    cliente: 'TERMACO TERM MAR CONT SERV ACESS LT',
    ativo: false,
  },
  {
    id: 3,
    placa: 'HVL8212',
    renavam: '8214532847',
    chassi: '12345678914521547',
    fabricante: 'HYUNDAI',
    modelo: 'HB0872',
    cor: 'PRETO',
    combustivel: 'GASOLINA',
    cliente: 'TERMACO TERM MAR CONT SERV ACESS LT',
    ativo: true,
  },
];



function Veiculo() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const headers = [
      { label: 'Selecionar', key: 'checkbox', isVisible: true },
      { label: 'Placa', key: 'placa', isVisible: true },
      { label: 'Renavam', key: 'renavam', isVisible: true },
      { label: 'Chassi', key: 'chassi', isVisible: true },
      { label: 'Fabricante', key: 'fabricante', isVisible: true },
      { label: 'Modelo', key: 'modelo', isVisible: true },
      { label: 'Cor', key: 'cor', isVisible: true },
      { label: 'Combustível', key: 'combustivel', isVisible: true },
      { label: 'Cliente', key: 'cliente', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];
    
    

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
      console.log('Dados selecionados:', selectedData);
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Veiculo'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaVeiculo headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default Veiculo